// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__426V3","tabList":"tabs_tabList__9kO1m"};